import React from "react";
import noop from "lodash/fp/noop";

export default React.createContext({
  onDelete: noop,
  onUnpublish: noop,
});
